export default __webpack_public_path__ + "static/media/ic-practice-test-g.988b15a8.svg";